// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"196":"azure","806":"date-input-polyfill","997":"clipboard"}[chunkId] + "." + {"196":"39e3d90fdb5f75e40ff2","806":"8b79e17c2f0fdc4b75ba","997":"f1c211a230d081281f6a"}[chunkId] + ".js";
};